<template>
  <div class="withdrawal">
    <div class="top" v-if="userInfo.adapay_account_status === 1">
      <div class="top-txt">
        可提现金额：
        <span class="price-txt">{{ userInfo.money }}元</span>
      </div>
      <div class="input-div">
        <span class="icon">￥</span>
        <input type="text" :placeholder="`提现金额不低于${deails.min > 0 ? deails.min : 0}元`"  v-model="price" class="input-txt">
        <span class="all-btn" @click="price = userInfo.money">全部</span>
      </div>
      <div class="tips">费率{{(deails.rate > 0 ? deails.rate : 0 ) * 100}}%（最低¥{{deails.min}}）</div>
    </div>
    <div v-else>
      <div class="card-title">开户信息</div>
      <div class="card-div">
        <div class="card-item">
          <div class="label">开户姓名</div>
          <input type="text" v-model="name" placeholder="请输入开户人姓名" class="val">
        </div>
        <div class="card-item">
          <div class="label">银行卡号</div>
          <input type="text" v-model="bank_acct" placeholder="请输入银行卡号" class="val">
        </div>
        <div class="card-item">
          <div class="label">银行编号</div>
          <input type="text" @click="showPicker = true" readonly v-model="bank_name" placeholder="请输入开户银行编号" class="val">
        </div>
        <div class="card-item">
          <div class="label">手机号</div>
          <input type="text" v-model="mobile" placeholder="请输入银行预留手机号" class="val">
        </div>
        <div class="card-item">
          <div class="label">邮箱</div>
          <input type="text" v-model="email" placeholder="请输入邮箱号" class="val">
        </div>
        <div class="card-item">
          <div class="label">身份证号</div>
          <input type="text" v-model="id_card" placeholder="请输入身份证号" class="val">
        </div>
        <div class="card-item">
          <div class="label">地址</div>
          <input type="text" v-model="address" placeholder="请输入身份证地址" class="val">
        </div>
        <div class="card-item" v-if="userInfo.adapay_account_status === 2">
          <div class="label">失败备注</div>
          <div class="val">{{ wrongRemarks }}</div>
        </div>
      </div>
    </div>
    <div class="submit-btn cur" v-if="userInfo.adapay_account_status === 1" @click="handleWithDrawal">申请提现</div>
    <div class="submit-btn" v-else-if="userInfo.adapay_account_status === 0">审核中...</div>
    <div class="submit-btn" :class="isOver ? 'cur' : ''" v-else-if="userInfo.adapay_account_status ===-1" @click="handleSubmit">提交审核</div>
    <div class="fixbtn" v-else-if="userInfo.adapay_account_status === 2">
      <div class="btn" @click="handleJump('UPLOADIDCARD')">编辑身份证</div>
      <div class="btn cur" @click="handleSubmit">重新提交审核</div>
    </div>
    <!-- <div class="submit-btn cur" @click="handleJump('UPLOADIDCARD')" v-else-if="userInfo.adapay_account_status === 2">审核失败，请重新提交审核</div> -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>
<script>
import { getAdapayAccount, postAdapayAccount, getWithdrawal, postWithdrawal } from '@/api/person'
export default {
  name: 'withdrawal',
  data () {
    return {
      price: '',
      name: '',
      bank_acct: '',
      mobile: '',
      email: '',
      bank_name: '',
      bank_code: '',
      id_card: '',
      address: '',
      showPicker: false,
      columns: [],
      deails: {},
      IDCardInfo: {},
      wrongRemarks: ''
    }
  },
  computed: {
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    },
    isOver () {
      return this.name && this.bank_acct && this.mobile && this.bank_name && this.id_card && this.address && this.email
    },
  },
  mounted () {
    this.IDCardInfo = JSON.parse(localStorage.getItem('cardInfo'))
    this.$nextTick(() => {
      if (this.IDCardInfo) {
        this.id_card = this.IDCardInfo.id_card
        this.address = this.IDCardInfo.address
        this.name = this.IDCardInfo.name
      }
      this.handleFun()
    })
  },
  methods: {
    handleWithDrawal() {
      let params = {
        money: this.price
      }
      postWithdrawal(params).then(res => {
        if (!res.code) {
          this.$toast(res.msg)
        } else {
          this.$router.push({
            path: '/balances'
          })
        }
      })
    },
    onConfirm (e, index) {
      this.bank_code = this.bank_key[index]
      this.bank_name = e
      this.showPicker = false
    },
    handleFun () {
      getAdapayAccount().then(res => {
        let info = res.data.info
        this.wrongRemarks = info.remarks
        if (info && Object.keys(info).length > 0) {
          this.name = info.full_name
          this.id_card = info.id_card
          this.address = info.address
          this.mobile = info.mobile
          this.email = info.email
          this.bank_code = info.bank_code
          this.bank_acct = info.bank_acct
        }
        this.columns = []
        this.bank_key = []
        for (let i in res.data.band_code) {
          this.columns.push(res.data.band_code[i])
          if (info.bank_code === i) {
            this.bank_name = res.data.band_code[i]
          }
          this.bank_key.push(i)
        }
      })
      getWithdrawal().then(res => {
        this.deails = res.data
      })
    },
    handleSubmit () {
      let params = {
        face_id: this.IDCardInfo.face_id,
        back_id: this.IDCardInfo.back_id,
        name: this.IDCardInfo.name,
        id_card: this.IDCardInfo.id_card,
        id_card_end: this.IDCardInfo.id_card_end,
        address: this.IDCardInfo.address,
        mobile: this.mobile,
        email: this.email,
        bank_code: this.bank_code,
        bank_acct: this.bank_acct,
      }
      postAdapayAccount(params).then(res => {
        if (!res.code) {
          this.$toast(res.msg)
        } else {
          this.$toast(res.msg)
          setTimeout(() => {
            this.$router.push({
              path: '/balance'
            })
          }, 100)
        }
      })
    },
    handleJump(type) {
      switch (type) {
        case 'UPLOADIDCARD':
          this.$router.push({
            path: '/uploadIDCard'
          })
          break

        default:
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.withdrawal {
  background-color: #1E2020;
  min-height: 100vh;
  width: 100vw;

  .top {
    height: 146px;
    background-color: #2F3131;
    padding: 0 14px;
    box-sizing: border-box;

    .top-txt {
      display: flex;
      align-items: center;
      padding-top: 24px;
      line-height: 12px;
      box-sizing: border-box;
      color: #939399;
      font-size: 12px;
      margin-bottom: 8px;

      .price-txt {
        color: #FFFFFF;
      }
    }

    .input-div {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E6E6E6;
      box-sizing: border-box;

      .icon {
        font-size: 22px;
        color: #F0E1C0;
        font-weight: bold;
        margin-right: 10px;
      }

      .input-txt {
        height: 100%;
        flex: 1;
        font-size: 18px;
        color: #fff;
        background-color: transparent;
        outline: none;
        border: none;

        &::placeholder {
          color: #CCCCCC;
        }
      }

      .all-btn {
        font-size: 18px;
        color: #FFFFFF;
        font-weight: 600;
      }
    }

    .tips {
      height: 44px;
      font-size: 12px;
      color: #E34B48;
      font-weight: 500;
      line-height: 44px;
    }
  }

  .card-title {
    height: 52px;
    line-height: 52px;
    font-size: 16px;
    color: #FFFFFF;
    font-weight: 500;
    padding-left: 14px;
    box-sizing: border-box;
  }

  .card-div {
    padding: 0 14px;
    box-sizing: border-box;
    background-color: #2F3131;

    .card-item {
      display: flex;
      border-bottom: 1px solid #666666;
      box-sizing: border-box;
      height: 56px;
      align-items: center;

      .label {
        font-size: 16px;
        font-weight: 500;
        color: #939399;
        width: 64px;
        margin-right: 20px;
      }

      .val {
        color: #fff;
        font-size: 16px;
        outline: none;
        border: none;
        background-color: transparent;
        flex: 1;

        &::placeholder {
          color: #CCCCCC;
        }
      }

      &:last-child {
        border: none;
      }
    }
  }
  .fixbtn {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 14px;
    margin-top: 20px;
    box-sizing: border-box;
    .btn {
      width: 48%;
      background-color: #F0E1C0;
      color: #504632;
      line-height: 48px;
      border-radius: 100px;
      font-size: 16px;
      color: #504632;
      font-weight: 600;
      text-align: center;
    }
  }
  .submit-btn {
    background-color: #6C685E;
    text-align: center;
    line-height: 48px;
    border-radius: 100px;
    font-size: 16px;
    color: #504632;
    font-weight: 600;
    width: 347px;
    height: 48px;
    margin-left: 14px;
    margin-top: 20px;

    &.cur {
      background-color: #F0E1C0;
      color: #504632;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/withdrawal.vue